module.exports = __webpack_public_path__ + "static/media/AWAY2.68b89942.svg";